import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import TruncateTextWithButton from '../../../../../../molecules/merchant/common/buttons/TruncateTextWithButton';

import css from './Staff.module.scss';
import { MerchantBookingStaffApi } from '../../../../../../interfaces/merchants/bookings/staff';
import User from 'src/domain/entities/User';
import { RSButtonLink } from 'src/reservation-page/RSButtonLink';
import { RSButtonAnchor } from 'src/reservation-page/RSButtonAnchor';
import {
  EventSchemeResource,
  CourseSchemeResource,
} from 'src/interfaces/reservation_flow';

interface Props {
  staff: MerchantBookingStaffApi;
  href: string;
  resource: EventSchemeResource | CourseSchemeResource | undefined;
  user?: User;
}

const Staff: React.FC<Props> = ({ staff, href, resource, user }) => {
  const intl = useIntl();
  const classes = classNames(css.Staff, css.NoBottomPadding);

  const { name, image, description } = staff;

  const ButtonContent = React.useMemo(() => {
    // 組織管理者・スタッフアクセスの場合はresourceが存在しないので、予約ボタンのみ表示する
    if (
      !resource ||
      (user && resource?.acceptable_customer_login_status !== 'guest')
    ) {
      return (
        <div className="flex justify-end">
          <div className="pc:max-w-[200px] grow">
            <RSButtonLink isBlock={true} href={href} variant="outline">
              {intl.formatMessage({
                id: 'merchants.bookingPages.bookReservation',
              })}
            </RSButtonLink>
          </div>
        </div>
      );
    }
    return (
      <div className="pc:gap-1.5 flex justify-end gap-1">
        {resource?.acceptable_customer_login_status === 'all' && (
          <div className="pc:max-w-[200px] flex-1 grow">
            <RSButtonLink isBlock={true} href={href} variant="outline">
              {intl.formatMessage({
                id: 'merchants.bookingPages.bookGuestReservation',
              })}
            </RSButtonLink>
          </div>
        )}
        {resource?.acceptable_customer_login_status === 'guest' && (
          <div className="pc:max-w-[200px] flex-1 grow">
            <RSButtonLink isBlock={true} href={href} variant="outline">
              {intl.formatMessage({
                id: 'merchants.bookingPages.bookReservation',
              })}
            </RSButtonLink>
          </div>
        )}
        {resource?.acceptable_customer_login_status !== 'guest' && (
          <div className="pc:max-w-[200px] flex-1 grow">
            <RSButtonAnchor
              isBlock={true}
              href={`/signin/user?return_to=${href}`}
              variant="outline"
            >
              {intl.formatMessage({
                id: 'merchants.bookingPages.bookLoginReservation',
              })}
            </RSButtonAnchor>
          </div>
        )}
      </div>
    );
  }, [href, intl, resource, user]);

  return (
    <div>
      <div className={classes} data-style={description ? 'wrap' : 'noWrap'}>
        {image && image.url && (
          <img className={css.Staff__Img} alt={name} src={image.url} />
        )}
        <div
          className={css.Staff__Texts}
          data-style={image && image.url && 'hasImage'}
        >
          <p className={css.Staff__Name}>{name}</p>
          {description && (
            <TruncateTextWithButton
              className={css.Staff__Description}
              text={description}
              maxLine={7}
            />
          )}
        </div>
      </div>
      <div className="px-[18px] pb-[18px] pt-2">{ButtonContent}</div>
    </div>
  );
};

export default Staff;
